import React, {useContext, useState} from 'react';
import { Table } from 'semantic-ui-react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import { AuthContext } from '../../Auth'

function Herramientas() {
    const { currentUser } = useContext(AuthContext)
    const [userName] = useState(currentUser.name)

    return (
    <div>
        <Inventario userName={userName} />
    </div>
    )
}

class Inventario extends React.Component{
    static contextType = AuthContext
    constructor(props){
        super(props)
        this.database=firebase.firestore()
        this.state={
            rows:[],
            filtro:'',
            useModal: false,
            nombre: '',
            cantidad: 0,
            tablaHidden : false,
            mensajeHidden : true,
        }
        this.currentUser = props.currentUser
    }
    componentDidMount() {
        this.getData()
    }
    getData=async()=>{
        try {
            const snapShot = await firebase.firestore()
                .collection('Herramientas')
                .orderBy('nombre', 'asc').get()
            const rows=[]
            for (let i = 0; i < snapShot.docs.length; i++) {
                if (!snapShot.docs[i].exists) break
                const item = snapShot.docs[i]
                const usuario = this.currentUser;
                const listaTrabajadores = item.data().ubicacion;
                const isInArray = listaTrabajadores.indexOf(usuario) > -1;
                if (isInArray === true){
                    rows.push({
                        id: snapShot.docs[i].id,
                        ...snapShot.docs[i].data()
                    })
                }
            }
            this.setState({
                rows:rows
            })
            if(rows.length === 0){
                this.setState({
                    tablaHidden: true,
                    mensajeHidden: false
                })
            } else {
                this.setState({
                    tablaHidden: false,
                    mensajeHidden: true
                })
            }
        }
        catch (e) {
            console.log(e.message)
            if (e.message === 'Failed to get document because the client is offline.') {
                return this.getData()
            }
        }
    }
    render(){
        return(
        <>
        <div  className="body tabla">
        <h2 hidden={this.state.mensajeHidden}>No hay Herramientas prestadas, favor de contactar con el encargado.</h2>
            <table hidden={this.state.tablaHidden}><tbody>
                <tr>
                    <th>Nombre</th>
                    <th>Fecha</th>
                </tr>
                {this.state.rows.map((row, i)=>{
                    return(
                        <Table.Row key={i}>
                            <Table.Cell>{row.nombre}</Table.Cell>
                            <Table.Cell>{row.fecha.toDate().toLocaleDateString()}</Table.Cell>
                        </Table.Row>
                    )
                })}
            </tbody></table>
        </div>
        </>
        )
    }
}

export default Herramientas